<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择所属门店" clearable size="small" filterable @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="员工：">
					<el-select v-model="formInline.employeeKeyId" placeholder="请选择员工" clearable size="small" filterable @change="handleEmployeeChange">
						<el-option v-for="item in employeeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="内容：">
					<el-input v-model="formInline.content" placeholder="请输入内容" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="发放月份：">
					<el-date-picker
						v-model="monthDateValue"
						clearable
						size="small"
						type="month"
						value-format="yyyy-MM"
						format="yyyy年MM月"
						placeholder="请选择月份"
						@change="handleMonthDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="创建时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="是否可发放">
					<el-select v-model="formInline.isFinished" placeholder="请选择" clearable size="small" @change="inputChange">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="可发放" :value="true"></el-option>
						<el-option label="不可发放" :value="false"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否发放">
					<el-select v-model="formInline.isGrant" placeholder="请选择状态" clearable size="small" filterable @change="inputChange">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="是" :value="true"></el-option>
						<el-option label="否" :value="false"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="提成类型：">
					<el-select v-model="formInline.type" placeholder="请选择提成类型" size="small" @change="inputChange">
						<el-option v-for="item in typeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/commission/main', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/commission/main', 'grant')" size="small" type="primary" class="el-icon-magic-stick" @click="handleGrantClick">发放</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId" height="550" @selection-change="handleSelectionChange">
				<template #monStr>
					<el-table-column label="提成月份" width="120" align="center">
						<template #default="scope">{{ scope.row.year }}年{{ scope.row.month }}月</template>
					</el-table-column>
				</template>
				<template #typeStr>
				<el-table-column label="提成类型" width="100" align="center">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleDetailClick(scope.row)">{{ scope.row.typeStr }}</el-link>
					</template>
				</el-table-column>
			</template>
			<template #money>
				<el-table-column label="提成金额(元)" min-width="110" align="center">
						<template #default="scope">
							<el-link :underline="false" style="color: #ff9900; font-weight: 600; white-space: nowrap" v-money="scope.row.money || 0" @click="handleDetailClick(scope.row)">
								￥{{ Number(scope.row.money || 0).toFixed(2) }} 元
							</el-link>
						</template>
					</el-table-column>
				</template>
			<template #isFinished>
				<el-table-column label="是否可发放" width="100" align="center">
					<template #default="scope">
						<el-tag v-if="scope.row.isFinished" type="success">可发放</el-tag>
						<el-tag v-else type="danger">不可发放</el-tag>
					</template>
				</el-table-column>
			</template>
			<template #isGrant>
				<el-table-column label="是否发放" width="100" align="center">
					<template #default="scope">
						<el-tag v-if="scope.row.isGrant" type="success">已发放</el-tag>
						<el-tag v-else type="danger">未发放</el-tag>
					</template>
				</el-table-column>
			</template>
			<template #grantMonthStr>
					<el-table-column label="发放月份" width="100" align="center">
						<template #default="scope">
							<span v-if="scope.row.grantMonth > 0">{{ scope.row.grantYear }}年{{ scope.row.grantMonth }}月</span>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 提成关联业务详情 -->
		<grantDialog ref="grantDialog"></grantDialog>
		<!-- 发放结果：检测不通过（关联业务仍有欠款）的提成明细 -->
		<el-dialog :visible.sync="blockDialogVisible" title="以下提成未予发放" width="900px" :close-on-click-modal="false" append-to-body>
			<el-alert v-if="blockSummary" :title="blockSummary" type="warning" :closable="false" show-icon style="margin-bottom: 12px"></el-alert>
			<el-table :data="blockList" border stripe size="small" max-height="420">
				<el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
				<el-table-column prop="businessCode" label="关联单号" min-width="170" align="center" show-overflow-tooltip>
					<template #default="scope">{{ scope.row.businessCode || "-" }}</template>
				</el-table-column>
				<el-table-column prop="typeStr" label="提成类型" width="110" align="center"></el-table-column>
				<el-table-column prop="employeeName" label="员工" width="100" align="center"></el-table-column>
				<el-table-column label="提成金额(元)" width="120" align="center">
					<template #default="scope">￥{{ Number(scope.row.money || 0).toFixed(2) }}</template>
				</el-table-column>
				<el-table-column prop="reason" label="未发放原因" min-width="200" align="center" show-overflow-tooltip></el-table-column>
			</el-table>
			<template #footer>
				<el-button type="primary" size="small" @click="blockDialogVisible = false">知道了</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
import { GetCommissionPageList, BatchGrantCommission } from "@/api/salaryApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import grantDialog from "@/views/accounting/storeCost/commission/grantDialog.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "提成记录"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				startTime: null,
				endTime: null,
				grantMonth: 0,
				grantYear: 0,
				content: "",
				employeeKeyId: "",
				type: 0,
				isFinished: null,
				isGrant: null
			},
			columnsData: [],
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "所属门店",
					isKeep: true,
					width: "120",
					align: "center",
				},
				{
					prop: "employeeName",
					label: "员工",
					isKeep: true,
					width: "120",
					align: "center",
				},
				{
					slot: "monStr",
					label: "提成月份",
					isKeep: true,
					width: "100",
					align: "center",
				},
				{
					slot: "typeStr",
				label: "提成类型",
				width: "100",
				align: "center"
			},
				{
					slot: "money",
					label: "提成金额(元)",
					width: "100",
					align: "center"
				},
				{
					prop: "content",
					label: "提成内容",
					minWidth: "200",
					align: "center"
				},
				{
					slot: "isFinished",
					label: "是否可发放",
					width: "100",
					align: "center"
				},
				{
					slot: "isGrant",
					label: "是否发放",
					width: "100",
					align: "center"
				},
				{
					prop: "grantUserName",
					label: "发放人",
					width: "90",
					align: "center"
				},
				{
					prop: "grantTime",
					label: "发放时间",
					width: "160",
					align: "center"
				},
				{
					slot: "grantMonthStr",
					label: "发放月份",
					width: "100",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center"
				}
			],
			storeList: [],
			dateValue: [],
			monthDateValue: "",
			employeeList: [],
			selectRowKeyIds: [],
			typeList: [],
			// 发放结果：检测不通过（关联业务仍有欠款）的明细弹窗
			blockDialogVisible: false,
			blockList: [],
			blockSummary: ""
		};
	},
	// 注册组件
	components: {
		grantDialog
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.GetEnumConfigListByCode();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetCommissionPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange() {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
							this.storeList.unshift({
								keyId: "",
								value: "全部门店"
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 日期选择器改变事件
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.getListData();
		},
		// 月份选择器改变事件
		handleMonthDateChange(val) {
			if (val) {
				var list = val.split("-");
				this.formInline.grantMonth = Number(list[1]);
				this.formInline.grantYear = Number(list[0]);
			} else {
				this.formInline.grantMonth = 0;
				this.formInline.grantYear = 0;
			}
			this.getListData();
		},
		// 所属门店改变事件
		handleStoreChange(val) {
			if (val) {
				this.formInline.storeKeyId = val;
			} else {
				this.formInline.storeKeyId = null;
				// 所属门店改变时，清空员工选择
				this.formInline.employeeKeyId = null;
				this.employeeList = [];
			}
			// 所属门店改变时，获取员工信息列表
			this.GetEmployeeInfoList();
			this.getListData();
		},
		// 员工选择改变事件
		handleEmployeeChange(val) {
			if (val) {
				this.formInline.employeeKeyId = val;
			} else {
				this.formInline.employeeKeyId = null;
			}
			this.getListData();
		},
		// 获取员工信息列表
		GetEmployeeInfoList() {
			const paramer = {
				keyId: this.formInline.storeKeyId
			};
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.employeeList = res.data || [];
						this.employeeList.unshift({
							keyId: "",
							value: "全部门店员工"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取员工信息失败!");
				});
		},
		// 发放事件
		handleGrantClick() {
			if (this.selectRowKeyIds.length == 0) {
				this.$message.error("请选择要发放的提成记录！");
				return;
			}
			this.$confirm("确认发放选中的提成记录吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.formInline.keyIds = this.selectRowKeyIds;
					BatchGrantCommission(this.formInline)
						.then((res) => {
							if (res.code == 1) {
								// 后端已按关联业务单据实时检测：检测不通过的通过 blocks 返回明细，其余已当场发放
								const blocks = (res.data && res.data.blocks) || [];
								if (blocks.length > 0) {
									this.blockList = blocks;
									this.blockSummary = res.msg || "";
									this.blockDialogVisible = true;
								} else {
									this.$message({
										type: "success",
										message: res.msg
									});
								}
								this.getListData();
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.$message.error("发放失败!");
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消发放"
					});
				});
		},
		// 选择事件
		handleSelectionChange(val) {
			this.selectRowKeyIds = val.map((item) => item.keyId);
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "CommissionType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.typeList = [];
						res.data.forEach((item) => {
							this.typeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.typeList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		// 详情点击事件
		handleDetailClick(row) {
			this.$refs.grantDialog.getGrantDialog(row);
		}
	}
};
</script>

<style scoped></style>
